module.exports = __webpack_public_path__ + "img/clock.44e2a12c.svg";